const AppControlGuids = {
  "TItemPriceHistoryView": "46E741106BC7441F8B1B09BEAE2D131D",
  "TTemplateConfigurationControl": "FA7E86C4E2814767AC1974704B6044A5",
  "TClientChargeView": "5844973DE2C045F4BDD5ED83F2C5C79A",
  "TItemCorrectionList": "D46072A3F0124E76861B21F555195E79",
  "TDunningConfigView": "026642E642A046D0A6CAF86A9ABDDC89",
  "TDunningInfo": "871D548555F24807BD7953789E820F18",
  "TBookingrecordExport": "712D66AE8EE244DBAC2BE4E1785F7922",
  "TInvoiceList": "57421BCDE6364802BB19F5C83ED4956D",
  "TClientDebit": "A038870AF291436CBCD0C52C5EF8D4AB",
  "TItemPriceMapping": "B34C35C9A3BD4761919ACE53BA06B5D6",
  "TDataOfficeTableView": "C2B4D4C3246C4451BF38AB647014CA40",
  "TOnBoardingStateView": "91D1088A52514182AAB04F6510C29C3E",
  "TSystemLogTable": "E737C0BD36924D6790904AA920CC0920",
  "TCartDocumentList": "91BD30F739C24EA3B10A0157E06FA68B",
  "TDunningTemplateConfigurationControl": "F0F4C0AF42D24BF18D7E0629DD04C5B7",
  "TItemTable": "F01D6DD01B2C4E18B72DAF16C9110C75",
  "TGlobalAdminSystemLogTable": "2CB06079DC624403AF97DE47A292201D",
  "TOutboxBook": "814D814F0A6A4E539D403C74900C186A",
  "TVehicleTableView": "DE34535BA6904DE6A3CB543B968B1847",
  "TCustomerBasedataConfiguration": "4929B5224456460F9426B4CF6C3D8F09",
  "TInvoiceTemplateImportTable": "B45587DE47F74BA8BDC2A244BA7968E1",
  "TAddressInfoView": "76FC5FFC0633479CA9769CB3D17E94E0",
  "TClientTableHnr": "3A11921464B142019BC95431D9CA8299",
  "TConfigLanguageImportView": "32EB3D20199E438F9C668AE26A4CBE22",
  "TFullCartStatus": "082B811AD7494ECC9C79065B290B86A2",
  "TCartItemsList": "1F4A43B89DED40FB95C3A38FDBC3CC9E",
  "TTaxKeyView": "F4D81F3ABECD4259A96CE4AE8438694A",
  "TCartList": "E8ED3F6ED2764F25B29FC702F6B696F8",
  "TCartTable": "F99D661774F94DA8B7F285A0DA2BF32B",
  "TCrewList": "D0D2743760004A6F95906D41BE9F36B0",
  "TBusinessAreaMappingTable": "E1F728F40BD947848680B472D2772BCE",
  "TTransportExport": "6430C7BF1105477A9CBF49D7CFAAEB38",
  "TItemGroupView": "7B2825EFBDCF49C5B23E621E5699DE71",
  "TCartExport": "F1783FAB9F23433F9E4AEEFF26CE00AA",
  "TStationTableView": "38B5A384E09B43D98DA51512862043C7",
  "TPayerTableView": "52A0441101AD42C4A7ECA4489B9BB12E",
  "TBusinessAreaTableView": "F34F48D8E9164A0A90B39275DFA88560",
  "TCartTypeTable": "C35C5F6B87F04640A05CC20FE8895C33",
  "TSepaConfigForm": "099C1B5361FD4904B8BD2B5944E926B8",
  "TInvoiceExport": "D3DD3217BAF44BC1B127BA86163E4F25",
  "TItemTypeView": "F428D3BF103143BE86B514CED228E0E4",
  "TCrudChangelog": "02BB77A066CE4F98852C363DB82D7941",
  "TLanguageTable": "4A7621AB91F74CC6BB4CFE648B70569B",
  "TAllClientList": "25925F5D7E1B4BFEA40D211A1FEE4BCB",
  "TInvoiceTemplateTable": "40DAED4C5CD24EEC86B4B860F9A23801",
  "TInvoiceTemplateConfigForm": "E42762EF7BFF4A6495D6F7C61E9B5211",
  "TConditionTable": "50876478630B4BB2961CD951B04513F9",
  "TImportOpenItem": "F327C24AC56B41F39B1EC7DB08CF2AB1",
  "TOpenItemList": "A41BC1E3AB6043348BEF8897F9F6FC5F",
  "TTestingSettingsConfig": "F2CD95E68E2541AD993A604AFA3C6988",
  "TPayerTableAllFieldsHidden": "C0AE9FB1EF9F40DF9FB7BEF581D56193",
  "TNotBillable": "32D70EB38E9B4458BFF6803B51F466D7",
  "TAlternativePayerTable": "CAF7CD78BDFD4555B72AB4DBE451C284",
  "TDTAServiceConfigView": "848AD614FE074ED1BC2388B7AA30C09E",
  "TClientList": "857CB853E1F14BB1BB7D8B894AA9F43A",
  "TOrdinanceList": "47808EF2C0284301A57627758700B428",
  "TItemGroupTypeView": "3F62D6E705824C3687F248B0B970B83C",
  "TGlobalTemplateConfigForm": "23EAB0B631C94FB1BC544D9C0E5F6375",
  "TPayerDataOfficeTable": "8723D23FFDE547579CDB18093F6EEBC6",
  "TAlternativePayerView": "B6A39F4844C34491969338F175853AFB",
  "TCrudCartAdditionaldata": "953A05FDB70646D787410E7112D21BA2",
  "TDunningConfigImportView": "6A981405898D46EA8EEF63426F564FA9",
  "TTrapoDetails": "552DE5E36F924904A309DCB77F02B7A0",
  "TOpenItemImportConfig": "E25436236DFA49C8B96A9261AAEC8AC6",
  "TTestRuleSettingsConfig": "1B2CF60D4AD04786AFDA09ACA287DF07",
  "TDunningLevelImportView": "A93218337DD64B928A99EDDF6F59405E",
  "TDictionaryImportView": "318703CDD5654F39BE711B75C7FB221B",
  "TWindmillExports": "9366AACD16374EA5AC932E8AB05A7647",
  "TClientTable": "26EF37AA16014857B7B698C38CBE39D9",
  "TInvoiceAutomationView": "57D5722DA04B40D789186BD855E0219B",
  "TInternalNotes": "BD87F560679E4A69BCB4BF27C7EF9B50",
  "TTransportList": "B10B1AA744C0440DAB3922314ABAC7A1",
  "TItemgroupTable": "BA258431C7814C8F94A0639AD0BE8DC4",
  "TDocumentJobTable": "AEA693FF8733432DBCF00416D3D0A237",
  "TInvoiceAutomationImportView": "DADDF31C777446C48C9B1A2051297620",
  "TDictionaryTable": "A1369AD252544CBAACBC4ED3CE48010D",
  "TCollectiveInvoiceTable": "4F661FA20E6D49988E4F38861774C08A",
  "TLanguageImportView": "AAFD412A606044BCA1D2C77FD23B9CD0",
  "TDunningLevelView": "0696B76D21114E92B365FB40EC4FF9EC",
  "TPayerTable": "A6CAF0CD61DB44F698BA54A53A24A082",
  "TPermanentOrdinanceForClient": "653938F81E1E44D2948231EBA73D6542",
  "TTrapoList": "C9C8028A88D44898936C841703FBC6AD",
  "TCartTableHnr": "74E97F8E595144379A0013438631C97F",
  "TEpostConfiguration": "7A24B0B02FBA437A8CB00FA169465421",
  "TBookingOptionsConfig": "6A4893F0A4084A75A6DCA1E16B66301A"
};
export default AppControlGuids;